import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import Footer from '../common/footer'
import Logo from '../common/logo'
import Screener1 from './screener_p1'
import Screener2 from './screener_p2'
import Eligible from './screener_eligible'
import Ineligible from './screener_ineligible'
import queryString from 'query-string'
import FetchWrapper from '../../utils/fetch_wrapper'
import moment from 'moment'

import config from '../../utils/config'

class Screener extends Component {
  constructor(props) {
    super(props)
    document.title = "Newtopia"
  }

  _backPage(cur) {
    switch(cur) {
      case '/1':
        return undefined
      case '/2':
        return '/1'
      case '/3':
        return '/2'
      case '/4':
        return '/3'
      default: return null
    }
  }

  async _nextPage(history, cur, input) {
    switch(cur) {
      case '/1':
        history.replace(history.location.pathname + history.location.search, input)
        return history.push('/2' + history.location.search)
      case '/2':
        history.replace(history.location.pathname + history.location.search, input)
        if (await this.isEligible(input)) {
          return  history.push('/eligible' + history.location.search)
        }
        return  history.push('/ineligible' + history.location.search)
      case '/eligible':
        return this.props.next()
      case '/ineligible':
        return this.props.history.goBack()
      default: return null
    }
  }

  extendRoute(R) {
    return props => (
      <R 
        {...props} 
        back={this._backPage.bind(this)}
        next={this._nextPage.bind(this, props.history)}
      />
    )
  }

  async isEligible(input) {
    const code = queryString.parse(this.props.location.search)
    const params = {
      regCode: code.regCode,
      answers: {
        gender: input.gender.value, 
        waistSize: parseInt(input.waist.value), 
        height: parseInt(input.height.value), 
        weight: parseInt(input.weight.value), 
        health: JSON.stringify(input.health.value)
      },
      plId: queryString.parse(window.location.search).plId
    }
    try {
      let response = await FetchWrapper.fetch(config.endpoint_get_screener_configuration, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { data } = response
      if (data.eligible === 'true') return true
    }
    catch(error) {
    }
    return false
  }

  header() {
    return (
      <div className="container header">
        <Logo />
      </div>
    )
  }

  footer() {
    const todayDate = moment()
    return (
      <div>
        <hr className="footer-separator" />
        <Footer />
        <div className="extra-screener-footer container">
          <p className="extra-footer-info">© {todayDate.format('YYYY')} NEWTOPIA INC. </p>
          <p className="extra-footer-info">The Newtopia program requires you to complete a personal profile. There is a question in the profile that asks about your family medical history (the family medical history question is marked as "voluntary" in the profile). Completion of this question, as well as providing a genetic (saliva) test sample, is strictly voluntary. If you choose to provide family medical history in the personal profile or provide a genetic (saliva) test sample, your authorization to process the genetic (saliva) test sample and/or analyze your family medical history is included in the Newtopia Genetics Consent Agreement that you will be asked to agree to on the following screen. That Agreement also describes confidentiality protections and restrictions on the use and disclosure of your genetic information.</p>
        </div>
      </div>
    )
  }
  
  render() {
    return (
      <div id="screener">
        <Router basename={this.props.match.path}>
          <div>
            <Route component={this.header}/>
            <Switch>
              <Route path="/1" render={this.extendRoute(Screener1)} />
              <Route path="/2" render={this.extendRoute(Screener2)} />
              <Route path="/eligible" render={this.extendRoute(Eligible)} />
              <Route path="/ineligible" render={this.extendRoute(Ineligible)} />
            </Switch>
            <Route path="/2" component={this.footer}/>
          </div>
        </Router>
      </div>
    )
  }
}

export default Screener